import { Component } from '@angular/core';
import { CountdownComponent } from 'libs/shared/src/lib/component/countdown/countdown.component';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  standalone: false
})
export class CustomCountdownComponent extends CountdownComponent {}
